export function filterByStatus(arrDomain, status) {
  if (arrDomain === null || !arrDomain.length) return arrDomain

  return arrDomain.filter((el) => el.status === status)
}
